// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { ActionCondition_abstract } from './../abstract/SagaActionLib/ActionCondition_abstract';
export class ActionCondition extends ActionCondition_abstract {}
